/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatSmileIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABk0lEQVR4nN2VvUoDQRDHoygiKgjq63hV4Iqbj0g2MwHFLk+giBFJq4hiaaNVFPFJrLQUTILxAbRQURE0sknEkNt4Zy5VFqa5mf39d2dm51KpoV6+709gRgySnCFJDVifgPQVSKtAWrY+z/PG+oIDyxKS1JG1EWH3wEL/YY8A6WEMcKPTgHS/VCqNxjn5wX/h2CHyJzygPPcLx7ZZhhNeKBTGbT6TCiBJ3bJCApjJaWI4ty0jxpF7PR+UALCehgVIqx0Bm+n08hSQFGPAXLGVcIpY338CjDHTzW+IM1EC7lh5CQuQvP22mxTtRmTZim7NcKx98S6B2sCKTHLjENAL1+l8YxaA5Tqce7kKgvw8kGyH92k5VpsGJGvW1wSxniDLI5A+AMkx88pcq3ayHroBatY5OYH1rusGHz1fZnsg2pgugYrzobVaVTYcOf1qjmbMLRKtzloLOO/ZXrc+R+rck9WmAUluExZ4xwk3xkwCy2UyuOz2HNfAcpQAXon84SDrHpB8xgEC6bPt81ZdNNuzoEOzvgHscXdctS/SSAAAAABJRU5ErkJggg==)
 */
export const ChatSmileIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M22 12a10 10 0 0 1-10 10H2.2a1 1 0 0 1-.75-1.66l2.06-2.37a.52.52 0 0 0 .04-.61A10 10 0 1 1 22 12ZM6.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm11 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-9.8 1.17a1 1 0 0 1 1.39.27 3.5 3.5 0 0 0 5.82 0 1 1 0 0 1 1.66 1.12 5.5 5.5 0 0 1-9.14 0 1 1 0 0 1 .27-1.4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
